<template>
    <h2 class="font-semibold mb-5 text-4xl tracking-tight leading-tight text-purple-600 dark:text-purple-400">
        <slot/>
    </h2>
</template>
